var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 252 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Gradiente_sem_nome);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome",
    "data-name": "Gradiente sem nome",
    x1: 135.9,
    y1: 24.2,
    x2: 250.6,
    y2: 24.2,
    gradientTransform: "translate(0 60) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09cc7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#07c28b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05a8b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#007ff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.2,19.8h-6.2c-1.5,0-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8h3.4v24.5c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8v-27.3c0-1.5-1.2-2.8-2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.2,
    cy: 13.3,
    r: 3.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46,52.6c-1.7,0-3-1.4-3-3v-14c0-3.2-.8-10.6-8.2-10.6s-8.2,7.4-8.2,10.6v14c0,1.7-1.4,3-3,3s-3-1.4-3-3v-14c0-10,5.7-16.7,14.3-16.7s14.3,6.7,14.3,16.7v14c0,1.7-1.4,3-3,3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.9,10.9c0,1.6-1.3,2.9-2.9,2.9h-6c-3.1,0-5.2,2-5.2,5v3.8h6c1.6,0,2.9,1.3,2.9,2.9s-.3,1.6-.9,2.1c-.5.5-1.3.9-2.1.9h-6v21c0,1.7-1.3,3-3,3s-3-1.3-3-3v-30.7c0-6.4,4.7-11,11.2-11h6c1.6,0,2.9,1.4,2.9,2.9v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.1,53.4c-9,0-16.4-7.8-16.4-17.3s7.3-17.3,16.4-17.3,16.4,7.8,16.4,17.3-7.3,17.3-16.4,17.3ZM90.1,24.5c-5.8,0-10.6,5.2-10.6,11.6s4.8,11.6,10.6,11.6,10.6-5.2,10.6-11.6-4.8-11.6-10.6-11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.6,52.8c-1.7,0-3-1.3-3-3v-17.2c0-7.2,5.9-13.1,13.1-13.1h4c1.7,0,3,1.3,3,3s-1.3,3-3,3h-4c-3.9,0-7.1,3.2-7.1,7.1v17.2c0,1.7-1.3,3-3,3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.3,18.7c-3.5,0-6.6,1.5-8.8,3.9-2.2-2.4-5.3-3.9-8.8-3.9-6.5,0-11.8,5.3-11.8,11.8v19.3c0,1.7,1.3,3,3,3s3-1.3,3-3v-19.3c0-3.2,2.6-5.7,5.7-5.7s5.7,2.6,5.7,5.7v18.7c0,1.7,1.3,3,3,3s3-1.3,3-3v-18.7c0-3.2,2.6-5.7,5.7-5.7s5.7,2.6,5.7,5.7v19.2c0,1.7,1.3,3,3,3s3-1.3,3-3v-19.2c0-6.5-5.3-11.8-11.8-11.8h.4ZM199.6,19.7c-9.1,0-16.4,7.4-16.4,16.4s7.4,16.4,16.4,16.4,2.8-1.2,2.8-2.8-1.2-2.8-2.8-2.8c-6,0-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9,9.5,3.6,10.6,8.6h-14.3c-1.5,0-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8h17.3c1.5,0,2.8-1.2,2.8-2.8s0-.2,0-.2v-.2c0-9.1-7.4-16.4-16.4-16.4h0ZM234.3,19.7h-9.7c-1.5,0-2.8,1.2-2.8,2.8v11.1c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8v-8.3h7c6,0,10.9,4.9,10.9,10.9s-4.9,10.9-10.9,10.9h-9.7c-1.5,0-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8h9.7c9.1,0,16.4-7.4,16.4-16.4s-7.4-16.4-16.4-16.4v-.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logoColor.7d6cf38220e3e21c48c073c29f5f09c8.svg";
export { ForwardRef as ReactComponent };